/**
 * Created by DynamicDog on 2016-12-13.
 *
 * The whole etikett editing/creation view.
 * Contains a header and extending panels
 */
import {Component,ViewChildren,QueryList} from '@angular/core';
import {EtikettService} from "../services/etikett.service";
import {EtikettPanelComponent} from "./etikettpanel.component";

var $ = window['$'];
@Component({
    selector: 'etikett-view',
    template: ` 
                <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
                <meta http-equiv="Pragma" content="no-cache">
                <meta http-equiv="Expires" content="0"><div class="etikett-view">
                <div class="header" id="etikettHeader"><span class="number">2</span>{{'Utforma etikett'|translate}}</div>
                <div *ngFor="let etikett of etikettService.getEtiketter(); let i = index">
                    <etikett-header [index]="i" (click)="onToggle(i)"></etikett-header>
                    <etikett-panel [etikett]="etikett" [index]="i" id="{{i}}"></etikett-panel>
                </div>
                <div style="margin-top:64px" class="light-button clickable" (click)="onAddEtikett()">{{'Skapa ny etikett'|translate}}</div>
                </div>
               `
})

export class EtikettViewComponent{
    @ViewChildren(EtikettPanelComponent) viewChildren: QueryList<EtikettPanelComponent>;
    constructor(private etikettService:EtikettService) {
    }

    // Show/hide a etikett panel
    private onToggle(index:number) {
        this.etikettService.toggleOpen(index);
        this.viewChildren.toArray()[index].carousel.refresh();
    }

    // Add a new etikett
    private onAddEtikett() {
        this.etikettService.addEtikett();
    }
}



// WEBPACK FOOTER //
// ./app/etikett/etikett.view.ts